import React from 'react'
import { redirect } from 'redux-first-router'
import * as R from 'ramda'
import { useFieldArray } from 'react-hook-form'
import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS } from 'constants/templates'
import { toProjects, toTemplates, toTemplatesCreator } from 'ducks/router'
import { useConfirmationModal, useSnackbar } from 'hooks'
import { useData } from './useData'
import { useDeleteCategoryModal } from './useDeleteCategoryModal'
import { useDeleteQuestionModal } from './useDeleteQuestionModal'
import { useEditNameModal } from './useEditNameModal'
import { useInternals } from './useInternals'
import { useMutations } from './useMutations'
import { useQueries } from './useQueries'
import { t } from 'ttag'
import { useModal } from 'hooks'

export const useEditCompetenciesModal = (state, handlers) => {
  const { uuid } = state
  const {
    handlePatchTemplate,
    handleRefetch,
    handleShowSnackbar,
  } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirm = React.useCallback(
    async (payload, { onFailureAction }) => {
      const { skills } = payload
      const { error, meta, response } = await handlePatchTemplate({
        skills,
        uuid,
      })

      if (response) {
        await handleRefetch()
        handleClose()
        handleShowSnackbar({
          message: t`Competencies were successully updated.`,
          type: 'success',
        })
      } else {
        onFailureAction?.({ message: error, type: meta?.HTTPstatus })
      }
    },
    [
      uuid,
      handleClose,
      handleRefetch,
      handlePatchTemplate,
      handleShowSnackbar,
    ],
  )

  return {
    handleCompetenciesClose: handleClose,
    handleCompetenciesConfirm: handleConfirm,
    handleCompetenciesOpen: handleOpen,
    isCompetenciesModalOpen: isOpen,
  }
}
